import { defineMessages } from 'react-intl'

const MESSAGES = defineMessages({
  accept_label: {
    defaultMessage: 'Ok',
    id: 'base.modal.accept_label'
  }
})

export default MESSAGES